import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "../lib/axios";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState({
    loading: true,
    authenticated: false,
    user: null,
    business: null,
    subscription: null,
    needsBusinessSetup: false,
    needsSubscription: false,
  });

  async function loadUser() {
    try {
      const { data } = await api.get("/Auth/me");

      setAuth({
        loading: false,
        authenticated: true,
        user: data.user,
        business: data.business,
        subscription: data.subscription,
        needsBusinessSetup: data.needsBusinessSetup,
        needsSubscription: data.needsSubscription,
      });
    } catch {
      setAuth({
        loading: false,
        authenticated: false,
        user: null,
        business: null,
        subscription: null,
        needsBusinessSetup: false,
        needsSubscription: false,
      });
    }
  }

  useEffect(() => {
    loadUser();
  }, []);

  const initials = useMemo(() => {
    if (!auth.user) return "";

    const first = auth.user.firstName?.[0] || "";
    const last = auth.user.lastName?.[0] || "";

    return `${first}${last}`.toUpperCase();
  }, [auth.user]);

  return (
    <AuthContext.Provider value={{ ...auth, initials, loadUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
